import React, { useCallback } from 'react';
import { FormattedDate, FormattedTime } from 'react-intl';

import { useMessage } from '@tmapy/intl';
import { Icon, SvgPaperclip } from '@tmapy/style-guide';

import type { EpsiOrderResponse } from '../../openapi/types';
import type { RouteId } from '../../routes';
import { useAppContext, useHistoryAction } from '../../hooks';
import { getCmdCtrlUrl } from '../../utils/getcmdctrlurl';
import { OrderBadge } from '../../orders/components/OrderBadge';
import type { ORDER_STATE } from '../../orders/constants';

import {
  epsiOrderMessages as msg,
  pspiObsahMessages,
  statusZadateleMessages,
} from './epsiOrderMessages';

export type EpsiOrderListItemProps = {
  data: EpsiOrderResponse;
};

export const EpsiOrderListItem: React.FC<EpsiOrderListItemProps> = ({ data }) => {
  const formatMessage = useMessage();
  const { appType } = useAppContext();
  const routeToDetail = useHistoryAction('vydejEpsiOrderDetail', { id: data.id });

  const handleClick = useCallback(
    (event: React.MouseEvent) => {
      if (event.ctrlKey || event.metaKey) {
        window.open(
          getCmdCtrlUrl('vydejEpsiOrderDetail' as RouteId, { appType, id: data.id }),
          '_blank',
        );
        return; // Ponech nativní chování
      }

      const selectText = window.getSelection();
      if (!selectText || selectText.toString() === '') {
        routeToDetail();
      }
    },
    [appType, data.id, routeToDetail],
  );

  return (
    <tr onClick={handleClick}>
      <td className='sg-a-ta-c'>
        <div className='sg-u-type-bold sg-a-fvn-tn'>{data.id}</div>
        {data.state && (
          <div className='sg-a-mt-1/2'>
            <OrderBadge state={data.state as ORDER_STATE} />
          </div>
        )}
      </td>
      <td>{data.dmvs_id_podani}</td>
      <td>
        <div>{data.zadatel?.jmeno}</div>
        {data.zadatel?.ico && (
          <div className='sg-u-type-sml sg-u-c-body-darkest sg-a-mt-1/2'>{data.zadatel.ico}</div>
        )}
      </td>
      <td>
        {data.status_zadatele && formatMessage.lookup(statusZadateleMessages, data.status_zadatele)}
      </td>
      <td>{data.pspi_obsah && formatMessage.lookup(pspiObsahMessages, data.pspi_obsah)}</td>
      <td className='sg-a-ta-r sg-a-ws-nw sg-a-fvn-tn'>
        {data.datum_platnosti && <FormattedDate value={new Date(data.datum_platnosti)} />}
      </td>
      <td className='sg-a-ta-r sg-a-ws-nw sg-a-fvn-tn'>
        {data.created && (
          <>
            <FormattedDate value={new Date(data.created)} />{' '}
            <FormattedTime value={new Date(data.created)} />
          </>
        )}
      </td>
      <td className='sg-a-w-0'>
        {data.has_priloha && (
          <span title={formatMessage(msg.attachmentTooltip)}>
            <Icon element={<SvgPaperclip />} size='med' />
          </span>
        )}
      </td>
    </tr>
  );
};
